import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 100,
};

export const applicationListTableControllerSlice = createSlice({
    name: 'applicationListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const { changeCurrentPage } = applicationListTableControllerSlice.actions;

export default applicationListTableControllerSlice.reducer;